import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { Conversation } from '../../src/builders/conversation_builder';
import { IConversationDatasourceModel } from '../conversations_interface';

export class ConversationsQuery implements IQuery {
  private _result: {
    conversations: Conversation[];
    hasMoreConversations: boolean;
  };

  constructor(private ngConversationDatastore: IDatasource<Conversation, IConversationDatasourceModel>) {
    Query.registerQuery(this, this.ngConversationDatastore);
  }

  run(): this {
    const conversations = _4.orderBy(this.ngConversationDatastore.values(), 'sent_timestamp', 'desc');
    const hasMoreConversations = !_4.isEmpty(this.ngConversationDatastore.model.nextPageURL);
    this._result = {
      conversations,
      hasMoreConversations
    };

    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/queries/conversations_query.ts